// ClientApp/src/hooks/useWindowSize.ts
import { useState, useEffect } from "react";

// この横幅より小さい場合はモバイル表示とみなします (Tailwindのmdブレークポイント)
const MOBILE_BREAKPOINT = 768;

export function useWindowSize() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { width, isMobile: width < MOBILE_BREAKPOINT };
}
